import { deltaClass, formatSignedSek } from './worksheetFormatters';

const PriceDelta = ({ delta }: { delta: number }) => <span className={`body-xs semibold ${deltaClass(delta)}`}>{formatSignedSek(delta)}</span>;

export default PriceDelta;
